{
  "my_calendar": {
    "upcoming": "Upcoming",
    "recent": "Recent",
    "calendar": "Calendar",
    "list": "List",
    "with": "With",
    "edit_key_activity": "Edit Key Activity",
    "mark_as_bd_activity": "Mark as BD Activity"
  }
}
